import { application } from "./application"
import ComposerController from "./composer_controller"
import EditorController from "./editor_controller"
import InlineUrlController from "./inline_url_controller"
import ModalController from "./modal_controller"
import SidebarController from "./sidebar_controller"
import ThemeController from "./theme_controller"
import PullToRefreshController from "./pull_to_refresh_controller"
import SearchFormController from "./search_form_controller"
import UploadController from "./upload_controller"

application.register("composer", ComposerController)
application.register("editor", EditorController)
application.register("inline-url", InlineUrlController)
application.register("modal", ModalController)
application.register("pull-to-refresh", PullToRefreshController)
application.register("search-form", SearchFormController)
application.register("sidebar", SidebarController)
application.register("theme", ThemeController)
application.register("upload", UploadController)
